import Vue from "vue";
import VueRouter from "vue-router";

import Explore from "@/views/Explore";
import Place from "@/views/Place";
import Preregister from "@/views/Preregister";
import Ticket from "@/views/Ticket";
import TicketPreregister from "@/views/TicketPreregister";

import Profile from "@/views/user/Profile";
import EditProfile from "@/views/user/EditProfile";
import ReservationHistory from "@/views/user/ReservationHistory";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "explore",
    component: Explore
  },
  {
    path: "/attivita/:place/presenze",
    name: "preregister",
    component: Preregister
  },
  {
    path: "/pre-registrazione/:place/:preregistration",
    name: "ticket-preregister",
    component: TicketPreregister
  },
  {
    path: "/attivita/:place",
    name: "place",
    component: Place
  },
  {
    path: "/prenotazione/:ticket",
    name: "ticket",
    component: Ticket
  },
  // profile
  {
    path: "/profilo",
    name: "profile",
    component: Profile,
    meta: { auth: true }
  },
  {
    path: "/profilo/modifica",
    name: "profile.edit",
    component: EditProfile,
    meta: { auth: true }
  },
  {
    path: "/profilo/prenotazioni",
    name: "profile.reservations",
    component: ReservationHistory,
    meta: { auth: true }
  },

  // auth
  {
    path: "/login",
    name: "auth.login",
    component: () =>
      import(/* webpackChunkName: "auth.login" */ "@/views/auth/Login"),
    props: true,
    replace: true // Don't leave trace in history
  },
  {
    path: "/registrazione",
    name: "auth.register",
    component: () =>
      import(/* webpackChunkName: "auth.register" */ "@/views/auth/Register")
  },
  {
    path: "/reset-password",
    name: "auth.resetPassword",
    component: () =>
      import(
        /* webpackChunkName: "auth.resetPassword" */ "@/views/auth/ResetPassword"
      )
  },
  {
    path: "/conferma-account",
    name: "auth.confirmAccount",
    component: () =>
      import(
        /* webpackChunkName: "auth.confirmAccount" */ "@/views/auth/ConfirmAccount"
      )
  }
];

const router = new VueRouter({
  routes
});

export default router;
